import styled from 'styled-components';
import * as colors from '../../../../components/common/colorConstants';
import { mediumHeightScreens, smallScreens } from 'components/common/fontElements';

export const Container = styled.div`
  position: relative;
  height: 100%;
  flex-direction: column;
  display: flex;
`;

export const CustomerDetailsContainer = styled.div`
  width: 400px;
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  text-align: center;

  padding: 30px 40px 30px;
  border-bottom: 1px solid ${colors.lightGray15};
  @media (max-height: ${smallScreens}) {
    padding: 20px 40px 20px;
  }
  @media (max-height: ${mediumHeightScreens}) {
    padding: 10px 40px 15px;
  }
`;

export const CustomerDetailsFormContainer = styled.div`
  width: 100%;
  font-family: Lato;
`;

export const CustomerDetailsHeaderContainer = styled.div`
  padding: 30px 40px 30px;
  border-bottom: 1px solid ${colors.lightGray15};
  @media (max-height: ${smallScreens}) {
    padding: 20px 40px 20px;
  }
  @media (max-height: ${mediumHeightScreens}) {
    padding: 10px 40px 15px;
  }
`;

export const Title = styled.p`
  font-family: Lato;
  font-size: 14px;
  color: ${colors.black1};
  margin: 0px;
  @media (max-height: ${smallScreens}) {
    font-size: 12px;
  }
  @media (max-height: ${mediumHeightScreens}) {
    font-size: 11px;
  }
`;

export const SubTitle = styled.p`
  font-family: Lato;
  font-size: 14px;
  color: ${colors.darkGray9};
  margin: 0px;
  @media (max-height: ${smallScreens}) {
    font-size: 12px;
  }
  @media (max-height: ${mediumHeightScreens}) {
    font-size: 11px;
  }
`;
